module.exports = __webpack_public_path__ + "img/lines-not-active.dd427968.svg";